import MainIcons from '@/icons/main';
import styles from './styles.module.css';
import ServiceSectionHead from '../ServiceSectionHead';

type ServiceIncludesProps = {
  items?: string[];
  note?: string;
};

const defaultItems = [
  'تخلیهٔ کامل روغن سوخته و شست‌وشوی مسیر',
  'فیلتر روغن اصلی (مان یا معادل)',
  '۴ لیتر روغن موتور تمام‌سینتتیک',
  'تنظیم فشار باد و بازدید لاستیک‌ها',
  'بازرسی مایعات: ترمز، خنک‌کننده، شیشه‌شور',
  'ثبت کیلومتر و یادآور سرویس بعدی در کارا',
];

export default function ServiceIncludes({
  items = defaultItems,
  note = 'اگر خودروی شما روغن بیشتر از ۴ لیتر نیاز داشته باشد، هر لیتر اضافه ۲۹۵٬۰۰۰ تومان هنگام تحویل محاسبه می‌شود.',
}: ServiceIncludesProps) {
  return (
    <section className={styles.container}>
      {/* <h2 className={styles.heading}>این خدمت شامل چه مواردی است؟</h2>

      <p className={styles.subtitle}>همهٔ موارد زیر در قیمت اعلام‌شده لحاظ شده است.</p> */}
      <ServiceSectionHead
        title={`این خدمت شامل چه مواردی است؟`}
        text={`همهٔ موارد زیر در قیمت اعلام‌شده لحاظ شده است.`}
      ></ServiceSectionHead>

      <div className={styles.grid}>
        {items.map((item) => (
          <div key={item} className={styles.item}>
            <span className={styles.check}>
              <MainIcons.CheckedIcon fill="var(--green)" width="12px" height="12px" />
            </span>

            <span className={styles.text}>{item}</span>
          </div>
        ))}
      </div>

      <div className={styles.note}>
        <svg width="17" height="17" className={styles.noteIcon}>
          <use href="#ic-bolt" />
        </svg>

        <div className={styles.noteText}>{note}</div>
      </div>
    </section>
  );
}
